import { useState, useRef, useEffect } from 'react';
import './AudioPlayer.scss';

function AudioPlayer() {
    const [playing, setPlaying] = useState(false);
    const audioRef = useRef(null);

    useEffect(() => {
        audioRef.current.volume = 0.5;
    }, []);

    const toggle = () => {
        if (playing) {
            audioRef.current.pause();
        } else {
            audioRef.current.play();
        }
        setPlaying(!playing);
    };

    return (
        <div className='audio-player'>
            <audio
                ref={audioRef}
                src='/She & Him - I Thought I Saw Your Face Today.mp3'
                loop
            />
            <button className='audio-btn' onClick={toggle} title={playing ? 'Pause music' : 'Play music'}>
                {playing ? (
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <rect x="2" y="1" width="4" height="12" rx="1" fill="currentColor"/>
                        <rect x="8" y="1" width="4" height="12" rx="1" fill="currentColor"/>
                    </svg>
                ) : (
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M3 1.5L12.5 7L3 12.5V1.5Z" fill="currentColor"/>
                    </svg>
                )}
            </button>
            <span className='audio-label'>{playing ? 'Now Playing' : 'Play Music'}</span>
        </div>
    );
}

export default AudioPlayer;
